import utils from "../Config/Config";
import config from "../Config/Config";
import axios from "axios";
import strings from "../Utils/strings";
import { reject } from "lodash";

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  headers: {
    apiKey: process.env.REACT_APP_API_KEY,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers[strings.clinicLogin.label_auth_token] = authService.getToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status == 403) {
      window.open("/#/" + strings.navigation.forbidden, "_self");
    } else if (response.status == 503 && navigator.onLine) {
      // window.open("/#/" + strings.navigation.serverDown, "_self")
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response) {
      if (error.response.status == 403) {
        window.open("/#/" + strings.navigation.forbidden, "_self");
      } else if (error.response.status == 503 && navigator.onLine) {
        // window.open("/#/" + strings.navigation.serverDown, "_self")
      }
    } else if (navigator.onLine) {
      // window.open("/#/" + strings.navigation.serverDown, "_self")
    }
    return Promise.reject(error);
  },
);

async function getTranslationLanguage(device, language) {
  try {
    return await axiosInstance.get(utils.apiName.getTranslationLanguage, {
      params: {
        platform: device,
        language,
      },
    });
  } catch (e) {
    return e.response;
  }
}
function getToken() {
  let token = localStorage.getItem(strings.clinicLogin.label_session);
  return token;
}

const getIsDoctorLogin = () => {
  return localStorage.getItem(strings.clinicLogin.label_login_type);
};

function getDoctorId() {
  return localStorage.getItem(strings.localStorage.doctorId);
}

function getDoctorCount() {
  // return localStorage.getItem(strings.localStorage.doctorCount);
  return "1";
}
function setQualification(token) {
  localStorage.setItem(strings.localStorage.qualification, token);
}

function getQualification() {
  return localStorage.getItem(strings.localStorage.qualification);
}

function setDoctorDescription(token) {
  localStorage.setItem(strings.localStorage.description, token);
}

function getDoctorDescription() {
  return localStorage.getItem(strings.localStorage.description);
}

function setDoctorSpecialty(token) {
  localStorage.setItem(strings.localStorage.speciality, token);
}

function getDoctorSpecialty() {
  return localStorage.getItem(strings.localStorage.speciality);
}

function setDoctorLanguage(token) {
  localStorage.setItem(strings.localStorage.language, token);
}

function getDoctorLanguage() {
  return localStorage.getItem(strings.localStorage.language);
}

function setDoctorWorkExperienceInYear(token) {
  localStorage.setItem(strings.localStorage.workExperienceInYear, token);
}

function getDoctorWorkExperienceInYear() {
  return localStorage.getItem(strings.localStorage.workExperienceInYear);
}

function setDoctorWorkExperienceInMonth(token) {
  localStorage.setItem(strings.localStorage.workExperienceInMonth, token);
}

function getDoctorWorkExperienceInMonth() {
  return localStorage.getItem(strings.localStorage.workExperienceInMonth);
}

function setDoctorEmailId(token) {
  localStorage.setItem(strings.localStorage.emailId, token);
}

function getDoctorEmailId() {
  return localStorage.getItem(strings.localStorage.emailId);
}

function setDoctorAddVitalSwitch(token) {
  localStorage.setItem(strings.localStorage.addVitalSwitch, token);
}

function getDoctorAddVitalSwitch() {
  return localStorage.getItem(strings.localStorage.addVitalSwitch);
}

function setDoctorVitalEmailId(token) {
  localStorage.setItem(strings.localStorage.vitalEmailId, token);
}

function getDoctorVitalEmailId() {
  return localStorage.getItem(strings.localStorage.vitalEmailId);
}

function setDoctorVitalMobileNumber(token) {
  localStorage.setItem(strings.localStorage.vitalMobileNumber, token);
}

function getDoctorVitalVitalMobileNumber() {
  return localStorage.getItem(strings.localStorage.vitalMobileNumber);
}

function setDoctorMobileNumber(token) {
  localStorage.setItem(strings.localStorage.mobileNumber, token);
}

function getDoctorMobileNumber() {
  return localStorage.getItem(strings.localStorage.mobileNumber);
}

function setDoctorGender(token) {
  localStorage.setItem(strings.localStorage.gender, token);
}

function getDoctorGender() {
  return localStorage.getItem(strings.localStorage.gender);
}

function setSelectedMonthNumber(token) {
  localStorage.setItem(strings.localStorage.selectedMonthNumber, token);
}

function getSelectedMonthNumber() {
  return localStorage.getItem(strings.localStorage.selectedMonthNumber);
}

const clearLocalStorageVariables = (variablesToRemove) => {
  variablesToRemove.forEach((variable) => {
    localStorage.removeItem(variable);
  });
};

function setToken(token) {
  localStorage.setItem(strings.clinicLogin.label_session, token);
}
function setClinicId(token) {
  localStorage.setItem(strings.clinicLogin.label_hospital_Id, token);
}
function setPhoneNumber(token) {
  localStorage.setItem(strings.clinicLogin.label_phone_number, token);
}
function setCountryCode(token) {
  localStorage.setItem(strings.clinicLogin.label_country_code, token);
}
function setHospitalAddress(token) {
  localStorage.setItem(strings.clinicLogin.label_hospital_address, token);
}
function setClinicName(token) {
  localStorage.setItem(strings.clinicLogin.label_clinic_name, token);
}
function setDoctorName(token) {
  localStorage.setItem(strings.clinicLogin.label_doctor_name, token);
}
function setIsDoctorLogin(token) {
  localStorage.setItem(strings.clinicLogin.label_login_type, token);
}
function setDoctorCount(token) {
  localStorage.setItem(strings.localStorage.doctorCount, token);
}
function setDoctorID(token) {
  localStorage.setItem(strings.localStorage.doctorId, token);
}
function getDoctorID(token) {
  localStorage.setItem(strings.localStorage.doctorId, token);
}
function getHospitalName() {
  return localStorage.getItem(strings.clinicLogin.label_clinic_name);
}
function getDoctorName() {
  return localStorage.getItem(strings.clinicLogin.label_doctor_name);
}
function getDoctorNameEn() {
  return localStorage.getItem(strings.clinicLogin.label_doctor_name_en);
}
function getDoctorNameVi() {
  return localStorage.getItem(strings.clinicLogin.label_doctor_name_vi);
}
function setDoctorNameEn(token) {
  return localStorage.setItem(strings.clinicLogin.label_doctor_name_en, token);
}
function setDoctorNameVi(token) {
  return localStorage.setItem(strings.clinicLogin.label_doctor_name_vi, token);
}
function getHospitalAddress() {
  return localStorage.getItem(strings.clinicLogin.label_hospital_address);
}
const localStorageInputValues = {
  setDoctorName,
  getDoctorName,
  setQualification,
  getQualification,
  setDoctorDescription,
  getDoctorDescription,
  setDoctorSpecialty,
  getDoctorSpecialty,
  setDoctorLanguage,
  getDoctorLanguage,
  setDoctorEmailId,
  getDoctorEmailId,
  setDoctorAddVitalSwitch,
  getDoctorAddVitalSwitch,
  setDoctorVitalEmailId,
  getDoctorVitalEmailId,
  setDoctorVitalMobileNumber,
  getDoctorVitalVitalMobileNumber,
  setDoctorMobileNumber,
  getDoctorMobileNumber,
  setDoctorGender,
  getDoctorGender,
  setSelectedMonthNumber,
  getSelectedMonthNumber,
  setDoctorWorkExperienceInYear,
  getDoctorWorkExperienceInYear,
  setDoctorWorkExperienceInMonth,
  getDoctorWorkExperienceInMonth,
  clearLocalStorageVariables,
};
function getCountryCode() {
  return localStorage.getItem(strings.clinicLogin.label_country_code);
  // return "91";
}

const authService = {
  getTranslationLanguage,
  getToken,
  getIsDoctorLogin,
  getDoctorId,
  getDoctorCount,
  localStorageInputValues,
  getCountryCode,
  setToken,
  setClinicId,
  setPhoneNumber,
  setCountryCode,
  setHospitalAddress,
  setClinicName,
  setIsDoctorLogin,
  setDoctorCount,
  setDoctorID,
  getHospitalName,
  getDoctorNameEn,
  getDoctorNameVi,
  setDoctorNameEn,
  setDoctorNameVi,
  getHospitalAddress,
  getDoctorName,
  setDoctorName,
  getDoctorID,
};

export default authService;
